<template>
  <div class="row" style="padding: 0px 5px 0px 5px;">
    <div class='alert alert-danger alert-dismissable' v-if='CollectorsvalidationErrors'>
      <ul v-if='CollectorsvalidationErrors'>
        <li v-for='err in CollectorsvalidationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
      </ul>
    </div>
    <div class='alert alert-success alert-dismissable' v-if='CollectorsSuccess'>
      {{CollectorsSuccess}}
    </div>
    <div class="row" style="padding: 15px 18px 0px 18px;">
      Code: {{valueScaned}}
    </div>

      <div class="row" style="padding: 15px 18px 0px 18px;">
        <div style="padding-right: 25%" class='form-group col-lg-4 col-sm-4'>
        <StreamBarcodeReader
            @decode="onDecode"
        ></StreamBarcodeReader>
      </div>
  </div>
  </div>
</template>
<script>
import axios from 'axios'
// import StreamBarcodeReader from 'vue-barcode-reader'
import { StreamBarcodeReader } from 'vue-barcode-reader'
export default {
  components: {
    StreamBarcodeReader
  },
  name: 'MobileReadActive',
  data () {
    return {
      branches: {},
      branch_id: 0,
      modelCollectors: {},
      modelCollectorId: '',
      records: [],
      selectedRecords: [],
      CollectorsSuccess: '',
      CollectorsvalidationErrors: '',
      valueScaned: ''
    }
  },
  methods: {
    UpdateCollectors () {
      this.collector_id = 0
      let i = this.branches.findIndex(x => x.id === parseInt(this.branch_id))
      if (i > -1) {
        this.collectors = this.branches[i].collectors
        this.collectors.unshift(this.emptyRec)
      }
    },
    // ======================================================
    onDecode (result) {
      this.valueScaned = result
      axios.post(this.$apiURL + 'auth/mobile-read-active', {
        token: localStorage.getItem('token')
      })
        .then(res => {
          this.isLoadingSave = false
          this.CollectorsSuccess = 'Done'
        })
        .catch(err => {
          if (err.response.data.message === 'Unauthenticated.') {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          this.CollectorsvalidationErrors = err.response.data.errors
          this.isLoadingSave = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/myComponents/MobileReadActive.vue